import { useUpdatePersonalInfoMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useUpdatePersonalInfo = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useUpdatePersonalInfoMutation(headerWithAuth, options);

  return mutate;
};

export {
  useUpdatePersonalInfo,
};
